import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";

const DeleteModal = (props) => {
  const {
    Name = "Delete",
    confirmDelete = () => {},
    btnName = "Delete",
    onClose = () => {},
    show = false,
  } = props;

  const [isDeleting, setIsDeleting] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (!modalElement) return;

    if (!show) {
      const handleModalHidden = () => {
        setIsDeleting(false);
        onClose();
      };

      modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

      return () => {
        modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
      };
    }
  }, [show, onClose]);

  const closeModal = () => {
    const modalElement = modalRef.current;
    if (modalElement) {
      try {
        const bootstrapModal = window.bootstrap?.Modal?.getInstance(modalElement) || 
                              new window.bootstrap.Modal(modalElement);
        if (bootstrapModal) {
          bootstrapModal.hide();
        }
      } catch (error) {
        console.error("Error closing modal with Bootstrap:", error);
      }

      if (window.$ && window.$(modalElement).modal) {
        try {
          window.$(modalElement).modal('hide');
        } catch (error) {
          console.error("Error closing modal with jQuery:", error);
        }
      }

      setTimeout(() => {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
                document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        
        // Remove all modal backdrops
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
      }, 150);
    }
    
    if (show) {
      onClose();
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    setIsDeleting(true);
    
    try {
      await confirmDelete();
      toast.success(`${Name} successfully`);
      setTimeout(() => {
        closeModal();
      }, 400); 
    } catch (error) {
      console.error("Error during deletion:", error);
      const errorMessage = error?.response?.data?.message || 
                          error?.message || 
                          "Something went wrong, please try again";
      toast.error(errorMessage);
      setTimeout(() => {
        closeModal();
      }, 400);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    if (!isDeleting) {
      closeModal();
    }
  };

  return (
    <>
      <div
        ref={modalRef}
        className={`modal custom-modal fade ${show ? 'show' : ''}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        id="delete_employee"
        role="dialog"
        style={{ display: show ? 'block' : 'none' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{Name}</h3>
                <p>Are you sure want to {Name}?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-primary continue-btn w-100"
                      onClick={handleConfirm}
                      disabled={isDeleting}
                    >
      {btnName}
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-primary cancel-btn w-100"
                      onClick={handleCancel}
                      disabled={isDeleting}
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default DeleteModal;
